module.exports = __webpack_public_path__ + "img/binaer.a6a36c04.png";